export default {
  state: () => ({
    live: {
      streamKey: '',
    },
  }),
  getters: {
    live(state) {
      return state.live;
    },
  },
  mutations: {
    UPDATE_LIVE_STREAM_KEY(state, payload) {
      state.live.streamKey = payload.streamKey;
    },
  },
  actions: {
    updateLiveStreamKey({ commit }, payload) {
      commit('UPDATE_LIVE_STREAM_KEY', payload);
    },
  },
};
